class OntarioObstetricalInitialLabInvestigation {
    public Hemoglobin: string;
    public BloodGroup: string;
    public BloodRhesus: string;
    public MeanCorpuscularVolume: string;
    public HumanImmunodeficiencyVirus: string;
    public Syphilis: string;
    public HepatitisBSurfaceAntigenHBsAg: string;
    public AntibodyScreen: string;
    public Platelets: string;
    public RubellaImmune: string;
    public UrineCS: string;
    public Chlamydia: string;
    public GeneralConditionGonorrheas: string;

    constructor(fields?: Partial<OntarioObstetricalInitialLabInvestigation>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalInitialLabInvestigation };
